import React from "react";
import {
  ShowView,
  ShowController,
  BooleanField,
  Pagination,
  Datagrid,
  ReferenceManyField,
  Tab,
  TabbedShowLayout,
  SimpleShowLayout,
  TextField
} from "react-admin";
import FootballTab from "./FootballTab";
import GirlsVolleyballTab from "./GirlsVolleyballTab";
import BasketballTab from "./BasketballTab";
import SoccerTab from "./SoccerTab";
import BaseballTab from "./BaseballTab";

const GameStatsShow = (props) => {
  return (
    <ShowController {...props}>
      {(controllerProps) => (
        <ShowView {...props} {...controllerProps}>
          <TabbedShowLayout>
            <Tab label="info">
              <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="sportCode" />
                <TextField source="seasonCode" />
                <TextField source="gameStatus" />
                <TextField source="gameDate" />
                <TextField source="gameDateString" />
                <TextField source="gameTimeString" />
                <BooleanField source="gameIsDistrict" />
                <TextField source="playoffRound" />
                <TextField source="homeTeamCode" />
                <TextField source="awayTeamCode" />
                <TextField source="gameStory" />
                <BooleanField source="gameStoryIsPublished" />
                <TextField source="internalNotes" />
              </SimpleShowLayout>
            </Tab>
            <Tab label="home stats">
              {controllerProps.record &&
                controllerProps.record.sportCode === "football" && (
                  <FootballTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-volleyball" && (
                  <GirlsVolleyballTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-basketball" && (
                  <BasketballTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-basketball" && (
                  <BasketballTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-soccer" && (
                  <SoccerTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-soccer" && (
                  <SoccerTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "softball" && (
                  <BaseballTab side="home" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "baseball" && (
                  <BaseballTab side="home" {...props} />
                )}
            </Tab>
            <Tab label="home players">
              <SimpleShowLayout>
                <ReferenceManyField
                  reference="gamePlayers"
                  target="school_sport_season_team_game_id"
                  source="home.id"
                  addLabel={false}
                  pagination={<Pagination />}
                  fullWidth
                >
                  <Datagrid rowClick="show">
                    <TextField source="id" />
                    <TextField source="player.id" />
                    <TextField source="player.person.name" />
                    <TextField source="player.jerseyNumber" />
                    <TextField source="player.position" />
                    <TextField source="sportCode" />
                  </Datagrid>
                </ReferenceManyField>
              </SimpleShowLayout>
            </Tab>
            <Tab label="away stats">
              {controllerProps.record &&
                controllerProps.record.sportCode === "football" && (
                  <FootballTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-volleyball" && (
                  <GirlsVolleyballTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-basketball" && (
                  <BasketballTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-basketball" && (
                  <BasketballTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "boys-soccer" && (
                  <SoccerTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "girls-soccer" && (
                  <SoccerTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "softball" && (
                  <BaseballTab side="away" {...props} />
                )}
              {controllerProps.record &&
                controllerProps.record.sportCode === "baseball" && (
                  <BaseballTab side="away" {...props} />
                )}
            </Tab>
            <Tab label="away players">
              <SimpleShowLayout>
                <ReferenceManyField
                  reference="gamePlayers"
                  target="school_sport_season_team_game_id"
                  source="away.id"
                  addLabel={false}
                  pagination={<Pagination />}
                  fullWidth
                >
                  <Datagrid rowClick="show">
                    <TextField source="id" />
                    <TextField source="player.id" />
                    <TextField source="player.person.name" />
                    <TextField source="player.jerseyNumber" />
                    <TextField source="player.position" />
                    <TextField source="sportCode" />
                  </Datagrid>
                </ReferenceManyField>
              </SimpleShowLayout>
            </Tab>
          </TabbedShowLayout>
        </ShowView>
      )}
    </ShowController>
  );
};

export default GameStatsShow;
